import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Loader, ScrollableContainer, StyledPageWrapper, Title } from "@monorepo/components";
import { routeConfig } from "@monorepo/constants/routeConfig";
import { useServiceGroupsQuery } from "@monorepo/services/api/services";
import { VoucherProvidersEnum } from "@monorepo/types";
import Typography from "@mui/material/Typography";
import { reverse } from "named-urls";

import { GsmVoucherVendorIcon } from "components/Services/GsmVoucherVendorIcon";
import { VouchersListItem } from "components/Services/GsmVoucherVendorsList";
import { FormWrapper, PageWrapper } from "components/Services/ServicesPage";

interface IGsmVoucherVendorGroupProps {
  vendor: VoucherProvidersEnum;
}

const GsmVoucherVendorGroup: React.FC<IGsmVoucherVendorGroupProps> = ({ vendor }) => {
  const { t } = useTranslation();
  const { data: serviceGroups, isFetching } = useServiceGroupsQuery(vendor);
  const history = useHistory();

  if (isFetching) {
    return <Loader />;
  }

  return (
    <StyledPageWrapper>
      <PageWrapper>
        <ScrollableContainer>
          <FormWrapper>
            <Title>{t("payments.new_payment")}</Title>
            {serviceGroups?.map((service) => {
              return (
                <VouchersListItem
                  role="presentation"
                  tabIndex={-1}
                  key={vendor}
                  onClick={() =>
                    history.push(
                      reverse(routeConfig.dashboard.services.gsmVouchers.buyGsmVoucher.vendor.serviceId, {
                        vendor: vendor,
                        serviceId: service.id,
                      }),
                      { ignoreGroup: true }
                    )
                  }
                >
                  <GsmVoucherVendorIcon vendor={vendor} />
                  <Typography component="span">{service.api_service_name}</Typography>
                </VouchersListItem>
              );
            })}
          </FormWrapper>
        </ScrollableContainer>
      </PageWrapper>
    </StyledPageWrapper>
  );
};

export default GsmVoucherVendorGroup;
